import { useRecoilState } from 'recoil'
import libraryDocumentsAtom from '../libraryDocuments.atom'
import { useEffect } from 'react'
import libraryDocumentsApi from '../libraryDocuments.api'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'

const useLibraryDocuments = () => {
  const { wait, loading } = useHttpLoader()
  const [libraryDocumentsState, setLibraryDocumentsState] = useRecoilState(libraryDocumentsAtom)

  useEffect(() => {
    if (!libraryDocumentsState.loaded) {
      wait(libraryDocumentsApi.loadLibraryDocuments(), (resp) => {
        if (resp.status === 'success') {
          setLibraryDocumentsState((prev) => ({
            ...prev,
            items: resp.body.items,
            loaded: true,
          }))
        }
      })
    }
  }, [])

  return { libraryDocumentsState, loading: loading || !libraryDocumentsState.loaded }
}

export default useLibraryDocuments
